import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import {
  Box,
  IconButton,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

// react-pdf needs the pdf.js worker; this points it to a CDN build matching the installed version.
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PdfViewer = ({ file }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [error, setError] = useState("");

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  if (!file) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      {error && <Alert severity="error">{error}</Alert>}

      <Box
        sx={{
          border: "1px solid #d0d7de",
          borderRadius: 2,
          overflow: "auto",
          maxWidth: "100%",
          bgcolor: "#fff",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        }}
      >
        <Document
          file={file}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={(err) =>
            setError("Failed to render PDF preview: " + err.message)
          }
          loading={
            <Box sx={{ display: "flex", justifyContent: "center", p: 6 }}>
              <CircularProgress />
            </Box>
          }
        >
          <Page pageNumber={pageNumber} width={950} />
        </Document>
      </Box>

      {numPages && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <IconButton
            disabled={pageNumber <= 1}
            onClick={() => setPageNumber((p) => p - 1)}
          >
            <NavigateBeforeIcon />
          </IconButton>
          <Typography fontSize={13} fontWeight={600}>
            Page {pageNumber} of {numPages}
          </Typography>
          <IconButton
            disabled={pageNumber >= numPages}
            onClick={() => setPageNumber((p) => p + 1)}
          >
            <NavigateNextIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default PdfViewer;
